import styled from 'styled-components';

export const SeoSrpTopContentBlockContainerWrap = styled.div(
  props => `
    display:flex;
    border-radius: ${props.theme.misc.borderRadius.xxlarge};
    padding: ${props.theme.spacing.base};
    background: ${props.backgroundColor || props.theme.colors.goWhite.base};
    background-color: ${props.theme.colors.goBrandBlue.medium};
    // border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    align-items: center;
    // margin-bottom: ${props.theme.spacing.base};
    `,
);
export const SeoSrpTopContentHeader = styled.h3(
  props => `
  color: ${props.color};
  font-weight: bold;
  `,
);

export const SeoSrpTopContentBlockTextWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    
    font-size: ${props.theme.font.custom(16)};
    margin-left: ${props.theme.spacing.base};
    width: 100%;
    `,
);

export const SeoSrpTopContentCasesInfoText = styled.span(
  props => `
    color: ${props.color || props.theme.colors.goGreen.base};
    font-size: ${props.theme.font.custom(14)};
    margin-top: ${props.theme.spacing.small};
    `,
);
